import { App } from '@/backoffice/app';
import { createAppRoot } from '@/shared/utils/create-app-root/create-app-root';

createAppRoot({ app: <App /> });
